import { render, staticRenderFns } from "./PortalMultipagosV1.vue?vue&type=template&id=25da641f&"
import script from "./PortalMultipagosV1.vue?vue&type=script&lang=js&"
export * from "./PortalMultipagosV1.vue?vue&type=script&lang=js&"
import style0 from "./PortalMultipagosV1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports